import React from 'react';
import '../styles/components/LoadingSpinner.css';

interface LoadingSpinnerProps {
  message?: string;
  fullPage?: boolean;
  compact?: boolean;
}

export default function LoadingSpinner({ message = 'Loading…', fullPage, compact }: LoadingSpinnerProps) {
  if (fullPage) {
    return (
      <div className="ls-fullpage">
        <span className="ls-fullpage-message">{message}</span>
      </div>
    );
  }
  return (
    <div className={compact ? 'planning-loading' : 'wt-container fade-in'}>
      <div className="planning-loading">{message}</div>
    </div>
  );
}
